import type { Nullable } from "@/types/nullable";
import type { ImageSourceSetsRecord } from "@/types/of-image.types";
import { MatchEventGoal_GoalEventType } from "@motain/xpa-proto-files-web/lib/types/match_events";
import { pxIcon } from "@/utils/helpers/pxIcon";

export const getGoalIcon = (
  type: MatchEventGoal_GoalEventType,
): Nullable<string | ImageSourceSetsRecord> => {
  switch (type) {
    case MatchEventGoal_GoalEventType.GOAL:
      return pxIcon(
        24,
        "https://images.onefootball.com/cw/icons/goal-light.svg",
        "https://images.onefootball.com/cw/icons/goal-dark.svg",
      );

    case MatchEventGoal_GoalEventType.OWN_GOAL: {
      return pxIcon(24, "https://images.onefootball.com/cw/icons/own-goal.svg");
    }

    case MatchEventGoal_GoalEventType.PENALTY_GOAL: {
      return pxIcon(
        24,
        "https://images.onefootball.com/cw/icons/penalty-light.svg",
        "https://images.onefootball.com/cw/icons/penalty-dark.svg",
      );
    }

    case MatchEventGoal_GoalEventType.RETRACTED_GOAL: {
      return pxIcon(
        24,
        "https://images.onefootball.com/cw/icons/retracted-goal-light.svg",
        "https://images.onefootball.com/cw/icons/retracted-goal-dark.svg",
      );
    }

    case MatchEventGoal_GoalEventType.MISSED_PENALTY_GOAL: {
      return pxIcon(
        24,
        "https://images.onefootball.com/cw/icons/penalty-missed-light.svg",
        "https://images.onefootball.com/cw/icons/penalty-missed-dark.svg",
      );
    }

    case MatchEventGoal_GoalEventType.UNRECOGNIZED: {
      return null;
    }
  }
};
